import React from 'react'
import Approver from "./Approver";
import Owner from "./Owner";

import {Checkbox, ChoiceGroup, Icon} from '@fluentui/react';
import {connect} from "react-redux";
import {addElement} from "../../../actions/CreateSiteActions/createSiteActions";
import {isConfirmGdprValid, isGdprValid, isSensitiveGdprValid} from "./Validator";
import {
    ADD_GDPR,
    ADD_SENSITIVE_GDPR,
    CONFIRM_GDPR} from "../../../actions/types";
import InfoTooltip from '../../formFields/InfoTooltip';

const warningIcon = <div className='warning'><Icon iconName="Warning" /></div>

class People extends React.Component
{
    componentDidMount() {
        
        if (this.props.gdpr == null && this.props.templateConfig != null && this.props.templateConfig.gdpr != null) {
            this.props.addGdpr(ADD_GDPR, this.props.templateConfig.gdpr);
        }

        if (this.props.sensitiveGdpr == null && this.props.templateConfig != null && this.props.templateConfig.sensitiveGdpr != null) {
            this.props.addGdpr(ADD_SENSITIVE_GDPR, this.props.templateConfig.sensitiveGdpr);
        }
    }

    onSelectOption(e, v) {
        this.props.addGdpr(ADD_GDPR, v.key);
    }

    onSelectOption2(e, v) {
        this.props.addGdpr(ADD_SENSITIVE_GDPR, v.key);
    }

    handleSelection() {
        const value = !this.props.confirm;
        this.props.addGdpr(CONFIRM_GDPR, value);
    }

    render() {
        const warning = this.props.possibleWarning && !isGdprValid() ? warningIcon : null;
        const error = warning && <div className='errorMessage'>Please select an option</div>;
        const toolTipContent1 = <span><a href='https://go.insideplus.abb.com/corporate-functions/legal-and-integrity/integrity/digital-data-cyber-data-privacy-portal/data-privacy-portal/privacy-law-in-european-union' target="_blank" rel="noopener noreferrer">
            https://go.insideplus.abb.com/corporate-functions/legal-and-integrity/integrity/digital-data-cyber-data-privacy-portal/data-privacy-portal/privacy-law-in-european-union</a></span>
        const toolTipContent2 = <span>
            <strong>Yes: </strong>Telephone number, address, email address, photographs, 
            employee ID numbers, device IDs, IP address, location data (or) Sensitive Personal data such as: 
            race/ethnic origin, political opinions, religious/philosophical beliefs, trade union membership, 
            health data, sex life/sexual orientation, genetic data, biometric data (e.g. fingerprints, facial 
            recognition), criminal records.<br/>
            <strong>No: </strong>The only personal data your site contains are fields captured by default 
            like: modified by, created by, administrator etc.
            </span>
        const toolTipContent3 = <span><strong>Yes: </strong>Race/ethnic origin, political opinions, 
            religious/philosophical beliefs, trade union membership, health data, sex life/sexual orientation, 
            genetic data, biometric data (e.g. fingerprints, facial recognition), criminal records. <br/>
            <strong>No: </strong>None of the above.
            </span>
        const warningSensitive = this.props.possibleWarning && !isSensitiveGdprValid() ? warningIcon : null;
        const errorSensitive = warningSensitive && <div className='errorMessage'>Please select an option</div>;
        const warningConfirm = this.props.possibleWarning && !isConfirmGdprValid()? warningIcon : null;
        const errorConfirm = warningConfirm && <div className='errorMessage'>Please select an option</div>;

        const sensitiveData = this.props.gdpr &&
            <div style={{position:'absolute'}}>
                <div style={{marginBottom:'20px'}} className="item-title" id="Sensitive-Personal-Data">
                    Do you intend to use your site to process (store, collect, manage, use, transfer)
                    <span style={{color:'#3f69af'}}> sensitive personal data</span>? 
                    <InfoTooltip content={toolTipContent3} />
                    {warningSensitive}
                </div>
                <ChoiceGroup
                    options={[
                        {
                            key: true,
                            text: 'Yes',
                            className: 'radio-Sensitive',
                            id: 'radio-Sensitive-Yes'
                        },
                        {
                            key: false,
                            text: 'No',
                            className: 'radio-Sensitive',
                            id: 'radio-Sensitive-No'
                        }
                    ]}
                    required={true}
                    onChange={this.onSelectOption2.bind(this)}
                    selectedKey={this.props.sensitiveGdpr}
                />
                {errorSensitive}
            </div>;

        return(
            <div>
                <div className='wizard-inside'>
                    {!(this.props.isIATU || this.props.isIAPCP)  ? <Owner /> : ""}
                    {!(this.props.isIATU || this.props.isIAPCP || (this.props.templateConfig || {}).hideApprover)  ? <Approver /> : ""}
                    
                    <div style={{marginBottom:'20px'}} className="item-title">
                        GDPR (General Data Protection Regulation)
                        <InfoTooltip content={toolTipContent1} />
                    </div>
                    <div style={{marginBottom:'20px'}} className="item-title">
                        Do you intend to use your site to process (store, collect, manage, use, transfer)
                        <span style={{color:'#3f69af'}}> personal data</span>? 
                        <InfoTooltip content={toolTipContent2} />
                        {warning}
                    </div>
                    <ChoiceGroup
                        options={[
                            {
                                key: true,
                                text: 'Yes',
								className: 'radio-Personal',
								id: 'radio-Personal-Yes'
                            },
                            {
                                key: false,
                                text: 'No',
								className: 'radio-Personal',
								id: 'radio-Personal-No'
                            }
                        ]}
                        required={true}
                        onChange={this.onSelectOption.bind(this)}
                        selectedKey={this.props.gdpr}
                    />
                    {error}
                </div>
                {sensitiveData}
                <div style={{position: 'absolute', top: '580px'}}> 
                    {warningConfirm}
                    <Checkbox label = 'I confirm that I have answered the questions to the best of my knowledge. I am aware that this confirmation is to be used for legal requirements of the General Data Protection Regulation (GDPR).'
                          checked={this.props.confirm} onChange={this.handleSelection.bind(this)} className='checkbox-GDPR-Confirm'/>
                    {errorConfirm}
                </div>

            </div>
        );
    }
}

const mapStateToProps  = state => ({
    gdpr: state.newSite.Gdpr,
    sensitiveGdpr: state.newSite.SensitiveGdpr,
    possibleWarning : state.wizard.nextStepRequested,
    confirm : state.newSite.ConfirmGdpr,
    isIATU: state.newSite.isIATU,
    isIAPCP: state.newSite.isIAPCP,
    templateConfig: state.newSite.Template.config
})


const mapActionToProp =
    {
        addGdpr : addElement,
    }
export default connect(mapStateToProps,mapActionToProp)(People)


// WEBPACK FOOTER //
// ./src/components/CreateSite/Step4/People.js